import { Theme } from '@mui/material';
import { Components } from '@mui/material/styles';

export const muiButtonOverride: Components<Theme>['MuiButton'] = {
  styleOverrides: {
    root: {
      textTransform: 'none',
      borderRadius: 6,
      minWidth: 'fit-content',
      fontWeight: 600,
      cursor: 'pointer',
    },
    contained: ({ theme, ownerState }) => ({
      backgroundColor: theme.vars.palette.primary[600],
      color: theme.vars.palette.common.white,
      borderColor: ownerState.color === 'error' ? theme.vars.palette.error.main : theme.vars.palette.primary[600],
      '&:hover': {
        backgroundColor: theme.vars.palette.primary[600],
        borderColor: ownerState.color === 'error' ? theme.vars.palette.error.main : theme.vars.palette.primary[600],
      },
      '&:active': {
        backgroundColor: theme.vars.palette.primary[800],
        borderColor: ownerState.color === 'error' ? theme.vars.palette.error.main : theme.vars.palette.primary[800],
      },
      '&:focus-visible': {
        outlineWidth: 2,
        outlineStyle: 'solid',
        outlineColor: theme.vars.palette.primary[300],
        outlineOffset: 2,
      },
      '&.Mui-disabled': {
        backgroundColor: theme.vars.palette.grey[200],
        color: theme.vars.palette.grey[500],
        borderColor: ownerState.color === 'error' ? theme.vars.palette.error.main : theme.vars.palette.grey[400],
      },
    }),
    outlined: ({ theme, ownerState }) => ({
      backgroundColor: theme.vars.palette.common.white,
      color: theme.vars.palette.primary[600],
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: ownerState.color === 'error' ? theme.vars.palette.error.main : theme.vars.palette.primary[600],
      '&:hover': {
        backgroundColor: theme.vars.palette.primary[200],
        color: theme.vars.palette.primary[700],
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: ownerState.color === 'error' ? theme.vars.palette.error.main : theme.vars.palette.primary[700],
      },
      '&:active': {
        backgroundColor: theme.vars.palette.common.white,
        color: theme.vars.palette.primary[800],
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: ownerState.color === 'error' ? theme.vars.palette.error.main : theme.vars.palette.primary[800],
      },
      '&:focus-visible': {
        backgroundColor: 'transparent',
        outlineWidth: 2,
        outlineStyle: 'solid',
        outlineColor: theme.vars.palette.primary[300],
        outlineOffset: 2,
      },
      '&.Mui-disabled': {
        backgroundColor: 'transparent',
        color: theme.vars.palette.grey[400],
        borderColor: ownerState.color === 'error' ? theme.vars.palette.error.main : theme.vars.palette.grey[400],
      },
    }),
    sizeSmall: {
      paddingX: 8,
      paddingY: 0,
      height: '36px',
    },
    sizeMedium: {
      paddingX: 12,
      paddingY: 0,
      height: '40px',
    },
    sizeLarge: {
      paddingX: 12,
      paddingY: 0,
      height: '48px',
    },
  },
};
